import {FooterType} from "../app/FooterType";
import {PledgerAction} from "@pledger/frontend-commons";
import {PledgerPageComponentState} from "../../services/ui/PledgerPageComponentState";
import {Reducer} from "redux";
import {ResetPasswordActions} from "./ResetPasswordActions";
import {WServiceActions} from "../../services/ws/WServiceActions";
import {resetPasswordWServiceActions} from "../../services/ws/resetPassword/resetPasswordWServiceActions";
import {
    CaptchaToken,
    VerifyCaptcha
} from "@pledger/frontend-commons/dist/ui/components/reCaptcha/ReCaptchaContainedProps";

const footerType = (state = FooterType.NONE, action : PledgerAction) => {
    switch (action.type) {
        default:
            return FooterType.NONE;
    }
};

const email = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case ResetPasswordActions.RESET_PASSWORD_CHANGE_EMAIL_ACTION.type:
            return action.payload.email;
        default:
            return state;
    }
};

const identifier = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case ResetPasswordActions.RESET_PASSWORD_CHANGE_IDENTIFIER_ACTION.type:
            return action.payload.identifier;
        default:
            return state;
    }
};

const dataError = (state = false, action : PledgerAction) => {
    switch (action.type) {
        case resetPasswordWServiceActions.POST_RESET_PASSWORD_EMAIL_FAILED_ACTION.type:
            return true;

        case ResetPasswordActions.RESET_PASSWORD_CHANGE_EMAIL_ACTION.type:
            return false;

        case ResetPasswordActions.RESET_PASSWORD_CHANGE_IDENTIFIER_ACTION.type:
            return false;
        default:
            return state;
    }
};

const captchaInvalid = (state :  boolean | string  = '', action: PledgerAction) => {
    switch (action.type) {
        case WServiceActions.POST_RESET_PASSWORD_EMAIL_SUCCEEDED_ACTION.type: {
            const captchaInvalid = action.payload.data.captchaResult !== true;
            if (captchaInvalid) {
                console.log("captchaInvalid : " + captchaInvalid)
            }

            return captchaInvalid;
        }
        case ResetPasswordActions.UPDATE_CAPTCHA_ACTION.type: {
            const captchaInvalid = !action.payload.captchaReady;
            if (captchaInvalid) {
                console.log("captchaInvalid : " + captchaInvalid)
            }

            return captchaInvalid;
        }
        case ResetPasswordActions.REGISTER_INVALID_CAPTCHA.type: {
            const captchaInvalid = true;
            if (captchaInvalid) {
                console.log("captchaInvalid : " + captchaInvalid)
            }
            return captchaInvalid;
        }

        default:
            return state;
    }
}
const verifyCaptcha = (state : VerifyCaptcha | string = '', action: PledgerAction) => {
    switch (action.type) {
        case ResetPasswordActions.UPDATE_CAPTCHA_ACTION.type:
            return action.payload.verifyCaptcha ?? '';

        default:
            return state;
    }
}

const captchaReady = (state = false, action: PledgerAction) => {
    switch (action.type) {
        case ResetPasswordActions.UPDATE_CAPTCHA_ACTION.type:
            return action.payload.captchaReady;

        default:
            return state;
    }
}

const captchaToken = (state : CaptchaToken = {}, action: PledgerAction) => {
    switch (action.type) {
        case ResetPasswordActions.UPDATE_CAPTCHA_TOKEN_ACTION.type:
            return action.payload.captchaToken;

        default:
            return state;
    }
}

export interface ResetPasswordPageComponentState extends PledgerPageComponentState {
    email: string;
    identifier: string;
    dataError: boolean;
    captchaInvalid:boolean | string;
    verifyCaptcha : VerifyCaptcha | string;
    captchaReady:boolean;
    captchaToken:CaptchaToken;
}

export const resetPassword : Reducer = (state={},action)=>{
    return{
        footerType: footerType(state.footerType, action),
        email: email(state.email, action),
        identifier: identifier(state.identifier, action),
        dataError: dataError(state.dataError, action),
        captchaInvalid:captchaInvalid(state.captchaInvalid,action),
        verifyCaptcha:verifyCaptcha(state.verifyCaptcha,action),
        captchaReady:captchaReady(state.captchaReady,action),
        captchaToken:captchaToken(state.captchaToken,action)
    }
}
